import { Link, useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useProduct } from "../context/ProductContext";
import { useAuth } from "../context/AuthContext";
import "../style/navbar.css";
import { FaHeart, FaShoppingCart, FaUserCircle } from "react-icons/fa";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";

export default function Navbar() {
  const { cart, wishlist } = useCart();
  const { filters, setFilters } = useProduct();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const totalCartItems = cart.reduce((sum, item) => sum + item.qty, 0);

  const [query, setQuery] = useState(filters.search || "");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setQuery(filters.search || "");
  }, [filters.search]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const trimmed = query.trim();

    setFilters((prev) => ({
      ...prev,
      search: trimmed,
    }));

    if (location.pathname !== "/product") {
      navigate("/product");
    }

    setQuery("");
  };

  const handleLogout = async () => {
    await logout();
    setDropdownOpen(false);
    toast.success("Logged out successfully");
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-top">
          <Link to="/" className="navbar-logo">
            ShopEasy
          </Link>

          <div className="navbar-right">
            {user ? (
              <div className="profile-dropdown" ref={dropdownRef}>
                <button
                  className="login-btn"
                  onClick={() => setDropdownOpen((prev) => !prev)}
                >
                  <FaUserCircle className="profile-icon" />
                  <span className="profile-text">{user.name?.split(" ")[0]}</span>
                </button>

                {dropdownOpen && (
                  <div className="dropdown-menu">
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/profile");
                        setDropdownOpen(false);
                      }}
                    >
                      My Profile
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/address");
                        setDropdownOpen(false);
                      }}
                    >
                      My Addresses
                    </button>
                    <button className="dropdown-item logout-item" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button className="login-btn" onClick={() => navigate("/login")}>
                <FaUserCircle className="profile-icon" />
                <span className="profile-text">Login</span>
              </button>
            )}

            <Link to="/wishlist" className="nav-icon">
              <FaHeart className="nav-svg-icon" />
              {wishlist.length > 0 && (
                <span className="badge">{wishlist.length}</span>
              )}
            </Link>

            <Link to="/cart" className="nav-icon">
              <FaShoppingCart className="nav-svg-icon" />
              {totalCartItems > 0 && (
                <span className="badge cart-badge">{totalCartItems}</span>
              )}
            </Link>
          </div>
        </div>

        <form className="navbar-search" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search for products, brands and more"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button className="search-btn" type="submit">
            🔍
          </button>
        </form>
      </div>
    </nav>
  );
}